<script setup lang="ts">
import type { UspComponentModel } from '@su4r-frontend/api';
defineProps<UspComponentModel>();
</script>

<template>
    <section class="tile tile-blur">
        <header class="flex flex-col gap-4 lg:gap-6">
            <div class="flex flex-col gap-4">
                <h2 v-if="title" class="order-2 text-3xl">{{ title }}</h2>
                <h3 v-if="subTitle" class="font-body order-1">{{ subTitle }}</h3>
                <hr class="order-3 border-white/25" />
            </div>
        </header>

        <section class="lg:grid-cols-auto-fit grid grid-cols-1 gap-x-6 gap-y-4 pt-4">
            <div v-for="(item, index) in usps" :key="`item-${index}`" class="flex flex-col gap-2">
                <SvgComponent icon="round-checkmark" class="h-6 w-6" />
                <h4 class="font-body font-semibold">{{ item.title }}</h4>
                <div v-html="item.body" />
            </div>
        </section>
    </section>
</template>
